import styled from 'styled-components';
import { BasketPxDetailsStyled } from '../BasketPxDetailsStyled';
import { rem } from 'polished';

export const BasketPxDetailsAC = styled(BasketPxDetailsStyled)`
    color: ${({ theme }) => theme.colors.grey5};

    .titleWrapper {
        color: ${({ theme }) => theme.colors.grey5};
    }

    .description {
        color: ${({ theme }) => theme.colors.grey5};

        .linkText {
            padding-bottom: unset;
        }
    }

    .detailTitle {
        font-size: ${({ theme }) => theme.fontSizes.h3};
    }

    .detail {
        .rightSection {
            button {
                font-size: ${({ theme }) => theme.fontSizes.h5};
                color: ${({ theme }) => theme.colors.grey5};

                &:hover {
                    .linkText {
                        border-color: ${({ theme }) => theme.colors.red};
                    }
                }
            }
        }
    }

    .continue {
        .continueLabel {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
        }
    }

    .status {
        background: ${({ theme }) => theme.colors.grey6};
        border-radius: ${rem(12)};

        .statusIcon {
            svg {
                top: ${rem(35)};
            }
        }

        .statusLabel {
            font-size: ${({ theme }) => theme.fontSizes.h4};
            line-height: ${rem(20)};
        }

        .statusDescription {
            font-size: ${({ theme }) => theme.fontSizes.h4};
            line-height: ${rem(22)};
        }

        .trash {
            font-size: ${({ theme }) => theme.fontSizes.h4};
            color: ${({ theme }) => theme.colors.grey5};

            svg {
                margin-bottom: ${rem(-4)};

                path {
                    fill: ${({ theme }) => theme.colors.grey5};
                }
            }

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.red};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.red};
                    }
                }
            }
        }

        button {
            background: ${({ theme }) => theme.colors.grey6};
        }
    }

    .summary {
        .leftSection,
        .rightSection {
            background: ${({ theme }) => theme.colors.grey6};
            border-radius: ${rem(12)};
            .summaryValue {
                font-size: ${({ theme }) => theme.fontSizes.h3};
            }

            .summaryDescription {
                font-size: ${({ theme }) => theme.fontSizes.h6};
            }
        }
    }
`;
